export { default } from '@/components/Auth/LegacyOnboardingRedirect';
